<template>
  <div>
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card color="wplgrey0">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(selectedAnalysisItem.basic.idi)}} Analysis
            <v-spacer/>
            {{displayDocumentIDGTypeA(selectedAnalysisItem.basic.tag, selectedAnalysisItem.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  Failure Mode Anlaysis
                </div>
                <v-spacer/>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="selectedAnalysisItem.basic.title"
                  hint="part name"
                  prepend-icon="title"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.type"
                  hint="type"
                  prepend-icon="grid_view"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedAnalysisItem.basic.id"
                  hint="part id"
                  prepend-icon="fingerprint"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.dis"
                  hint="discipline"
                  prepend-icon="engineering"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.cause"
                  prepend-icon="adjust"
                  hint="cause"
                  persistent-hint
                  readonly                  >
                </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.effect"
                  prepend-icon="warning"
                  hint="effect"
                  persistent-hint
                  readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.detect"
                  label="detect"
                  prepend-icon="straighten"
                  hint="detects"
                  persistent-hint
                  readonly
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.cond"
                  prepend-icon="manage_history"
                  hint="condition"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.patt"
                  prepend-icon="scatter_plot"
                  hint="pattern"
                  persistent-hint
                  readonly
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedAnalysisItem.char.rate"
                  prepend-icon="running_with_errors"
                  hint="perMhrs "
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2 mt-4">
                  Failure Mode Description
                </div>
                <v-spacer/>
              </v-layout>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2 mt-2 mb-4">
                  {{selectedAnalysisItem.char.com}}
                </div>
                <v-spacer/>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
              <v-spacer/>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
// import OrderNew from "@/finance/order/components/OrderNew";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import master from "@/data/forms/mixins/master.js";
export default {
  // eslint-disable-next-line
  mixins: [
    displayFunctions,
    master,
    dateFunctions,
    apptheme,
    numberFunctions,
    financeFunctions
  ],
  components: {
    // OrderNew
  },
  computed: {
    ...mapGetters(["getAnalysisList", "getCurrentPage"]),
    // selected task item
    selectedAnalysisItem() {
      return this.analysis;
    }
  },
  props: {
    analysis: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
